<template>
  <div v-if="!firebaseConfigured">
    <router-view />
  </div>

  <div v-else-if="!authReady || !siteUserReady" class="access-gate">
    <div class="access-gate__spinner"></div>
  </div>

  <div v-else-if="!isLoggedIn" class="access-gate">
    <div class="access-gate__panel">
      <h1 class="access-gate__title">Space Base</h1>
      <p class="access-gate__body">Sign in to play - Matt approves new accounts before they can access any Around Table Round games.</p>
      <p v-if="authError" class="access-gate__error">{{ authError }}</p>
      <button type="button" class="btn btn-primary btn-lg" @click="doLogin">
        <i class="bi bi-google me-1"></i> Sign in with Google
      </button>
    </div>
  </div>

  <div v-else-if="!isApproved" class="access-gate">
    <div class="access-gate__panel">
      <h1 class="access-gate__title">Almost there</h1>
      <p class="access-gate__body">
        Hi {{ user.displayName || user.email }} - your account is waiting on Matt's approval.
        You'll get in automatically here as soon as he approves you, no need to refresh.
      </p>
      <button type="button" class="btn btn-outline-light" @click="doLogout">Sign out</button>
    </div>
  </div>

  <template v-else>
    <AdminPanel v-if="isSiteAdmin" />
    <router-view />
  </template>

  <BugResolutionNotice v-if="firebaseConfigured" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AdminPanel from './components/shared/AdminPanel.vue';
import BugResolutionNotice from './components/shared/BugResolutionNotice.vue';
import { firebaseConfigured } from './firebase';

export default {
  name: 'App',
  components: { AdminPanel, BugResolutionNotice },
  data() {
    return { authError: null, firebaseConfigured };
  },
  computed: {
    ...mapState(['user', 'authReady', 'siteUserReady']),
    ...mapGetters(['isLoggedIn', 'isApproved', 'isSiteAdmin']),
  },
  methods: {
    async doLogin() {
      this.authError = null;
      try {
        await this.$store.dispatch('login');
      } catch (err) {
        this.authError = err.message;
      }
    },
    doLogout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style>
.access-gate {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.access-gate__panel {
  max-width: 420px;
  text-align: center;
  background: rgba(10, 16, 32, 0.7);
  border: 1px solid #2a3a5c;
  border-radius: 0.6rem;
  padding: 2rem 1.5rem;
}

.access-gate__title {
  color: #e8f0ff;
  margin-bottom: 0.75rem;
}

.access-gate__body {
  color: #93a5c4;
  margin-bottom: 1.25rem;
}

.access-gate__error {
  color: #ff6a6a;
  font-size: 0.9rem;
}

.access-gate__spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 3px solid #2a3a5c;
  border-top-color: #3ad6ff;
  border-radius: 50%;
  animation: access-gate-spin 0.8s linear infinite;
}

@keyframes access-gate-spin {
  to { transform: rotate(360deg); }
}
</style>
